// OneDrive:IgnoreCodeCoverage

import { createSingleEvent } from '../SingleEventBase';
import { IEventType } from '../EventBase';
import { IEvent, EventFieldType } from '../IEvent';
export interface IPLTHttpRequestSingleSchema {
    /**
     * The start time of the request
     */
    startTime: number;
    /**
     * The url for the request
     */
    url: string;
    /**
     * Time it takes for the request to complete
     */
    duration: number;
}

export interface IPLTHttpRequest extends IEvent {
    data: IPLTHttpRequestSingleSchema;
}

export type PLTHttpRequest = IPLTHttpRequest;

export const PLTHttpRequest: IPLTHttpRequestType = createSingleEvent<IPLTHttpRequestSingleSchema>({
    eventName: 'PLTHttpRequest,',
    shortEventName: 'PLTHttpRequest',
    samplingFeature: { ODB: true, ODC: 'PLTHttpRequestSampling', Fallback: false }
}, {
    startTime: EventFieldType.Number,
    url: EventFieldType.String,
    duration: EventFieldType.Number
});

export interface IPLTHttpRequestType extends IEventType<IPLTHttpRequestSingleSchema> {
    prototype: PLTHttpRequest;
    /**
     * This will create a single PLTHttpRequest event
     * @param data {IPLTHttpRequestSingleSchema}     * -required startTime - The start time of the request
     * -required url - The url for the request
     * -required duration - Time it takes for the request to complete
     * @param parent {IEvent} The optional parent for this event
     */
    logData(this: typeof PLTHttpRequest, data?: IPLTHttpRequestSingleSchema, parent?: IEvent): PLTHttpRequest;
}

export default PLTHttpRequest;
